import './Footer.css';

import { useTranslation } from 'react-i18next';

function Footer() {

  const { t } = useTranslation();

  return (

    <footer className="footer">

      <div className="footer-container">

        <p>
          {t('footer.copyright')}
        </p>

        <p>
          {t('footer.madeWith')}
        </p>

      </div>

    </footer>

  );

}

export default Footer;